import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { auth, translate, Timer, ui, utils } from 'parking-react-common'

import Button from '../components/Button'

const { withTimer } = Timer

const phoneCodeThrottlingDelta = utils.configVar('PHONE_CODE_DELTA')


const ResendCodeItem = ({ t, dispatch, time, formattedTime, phone }) => {
    const labelText = time > 0 ? `${formattedTime}` : t('Resend')
    const isDisabled = time > 0
    return (
        <Button
            label={ labelText }
            size={ ui.SIZE.large }
            onClick={ () => dispatch(auth.requestCode(phone)) }
            isBlock
            disabled={ isDisabled }
        />
    )
}

function mapStateToProps(state) {
    const phoneCodeSentAt = auth.getPhoneCodeSentAt(state)
    const phoneCodeSentAtAsString = new Date(phoneCodeSentAt).toISOString()
    return {
        startedAt         : phoneCodeSentAtAsString,
        countdownDuration : phoneCodeThrottlingDelta,
        shouldOverrun     : false
    }
}

ResendCodeItem.propTypes = {
    phone         : PropTypes.string,
    formattedTime : PropTypes.string,
    time          : PropTypes.number
}

export default compose(
    translate(),
    connect(mapStateToProps),
    withTimer
)(ResendCodeItem)
